import { farmKeys, useFarm } from '../../queries/FarmQueries';
import { Link, useNavigate, useParams } from 'react-router';
import { useAlpacasForFarm } from '../../queries/AlpacaQueries';
import AppLayout from '../../components/AppLayout';
import { FaEdit } from 'react-icons/fa';
import ShowPending from '../../components/ShowPending';
import ShowError from '../../components/ShowError';
import { formatPhoneNumbers } from '../../helpers/formatters';
import FarmAddressApi from '../../apis/farm_address_api';
import { useQueryClient } from '@tanstack/react-query';
import { handleError } from '../../apis';
import { toast } from 'react-toastify';
import AlpacaRosterTable from '../../components/AlpacaRosterTable';

export default function FarmPage() {
  const params = useParams();
  const farmId = params?.id ? +params.id : 0;
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { data: farm, isError, isPending, error } = useFarm(farmId);
  const { data: alpacas } = useAlpacasForFarm(farmId);

  const handleDelete = async () => {
    const proceed = window.confirm(
      'Deleting a farm can not be undone. Are you sure?',
    );
    if (!proceed) return;
    try {
      await FarmAddressApi.deleteFarm(farmId);
      queryClient.removeQueries({ queryKey: farmKeys.detail(farmId) });
      queryClient.invalidateQueries({ queryKey: farmKeys.all });
      navigate('/farms');
    } catch (error) {
      const message = handleError(error);
      toast.error(message);
    }
  };

  return (
    <AppLayout>
      <ShowPending isPending={isPending} />
      <ShowError error={error} isError={isError} />
      <div className='w-full'>
        <div className='flex items-start justify-center'>
          <h3 className='mb-0 text-center text-2xl dark:text-gray-300'>
            {farm?.name ?? ''} Farm
          </h3>
          <Link
            to={`/update-farm/${farm?.farmId}`}
            className='ml-4 p-1 text-xs font-bold uppercase hover:opacity-70'
          >
            <div className='flex items-center gap-2'>
              <FaEdit /> Edit
            </div>
          </Link>
        </div>
        <div
          className={`mb-2 flex justify-center text-xs font-bold uppercase ${
            farm?.active ? '' : 'text-amber-500 dark:text-amber-200'
          }`}
        >
          {farm?.active ? 'Active' : 'Archived'}
        </div>

        <div className='flex items-center justify-center gap-8 max-[640px]:flex-col max-[640px]:items-start max-[640px]:ps-4'>
          <div>
            {farm?.address1 && <p>{farm.address1}</p>}
            {farm?.address2 && <p>{farm.address2}</p>}
            {farm?.city && (
              <p>
                {farm.city}, {farm?.state?.abbreviation} {farm.zipcode}{' '}
              </p>
            )}
          </div>
          <div>
            {farm?.phoneNumber && <p>{formatPhoneNumbers(farm.phoneNumber)}</p>}
            {farm?.email && <p>{farm.email}</p>}
          </div>
        </div>

        <div className='pt-4'>
          <h4>{farm?.name} Alpacas</h4>
          {alpacas && <AlpacaRosterTable alpacas={alpacas ?? []} />}
        </div>

        <div className='flex justify-end p-4'>
          <button
            className='my-2  rounded-md border border-rose-600 bg-rose-500 p-2 text-xs font-bold uppercase text-white hover:border-rose-700 hover:bg-rose-600 dark:border-rose-500 dark:bg-rose-500  dark:hover:border-rose-600  dark:hover:bg-rose-600 '
            type='button'
            title={`Delete ${farm?.name ?? 'Farm'}`}
            onClick={handleDelete}
          >
            Delete Farm
          </button>
        </div>
      </div>
    </AppLayout>
  );
}
